/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smart_Select_HelpInputs */



/**
* | output |
* | --- |
* | "When performing automatic format, Selected Events are only formatted if required." |
*
* @param {Smart_Select_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const smart_select_help = /** @type {((inputs?: Smart_Select_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smart_Select_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lors de l’auto-formatage, les événements sélectionnés ne sont formatés que si nécessaire.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bei der automatischen Formatierung werden ausgewählte Ereignisse nur dann formatiert, wenn dies erforderlich ist.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Quando si esegue la formattazione automatica, gli eventi selezionati vengono formattati solo se necessario.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("При выполнении автоматического форматирования выбранные события форматируются только при необходимости.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Al realizar el formato automático, los eventos seleccionados solo se formatean si es necesario.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("执行自动格式化时，仅当需要时才会对选定事件进行格式化。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動フォーマットを実行する場合、選択したイベントは必要な場合にのみフォーマットされます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित फॉर्मेटिंग करते समय, चयनित इवेंट्स को केवल तभी फॉर्मेट किया जाता है जब आवश्यक हो।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ao executar a formatação automática, os eventos selecionados são formatados somente se necessário.")
	return /** @type {LocalizedString} */ ("When performing automatic format, Selected Events are only formatted if required.")
});